import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // ✅ URL से id लेने के लिए
import {
  closeModal,
  formatTime,
  ToastMain,
  SweetAlertShow,
} from "../../master/Master";
import {
  salaryUpdate,
  workingSchedulesList,
  EmploymentAdd,
  EmploymentRevision,
} from "../../../api/Staff";
import { getstaffwithid } from "../../../api/FacultyService";

const SaleryDetails = () => {
  const hasAccess = usePrivateLink();
  const { id } = useParams();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalData, setModalData] = useState("");
  const [workingSchedules, setWorkingSchedules] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState("");
  const [hours, setHours] = useState("");
  const hasSalary = teacher?.employment_histories?.length > 0;

  const handleScheduleChange = (e) => {
    const scheduleId = e.target.value;
    setSelectedSchedule(scheduleId);

    const schedule = workingSchedules.find(
      (s) => String(s.id) === String(scheduleId),
    );

    if (schedule) {
      setHours(schedule.total_hours_per_day);
    } else {
      setHours("");
    }
  };

  const daysList = [
    { key: "Sun", label: "Sun" },
    { key: "Mon", label: "Mon" },
    { key: "Tue", label: "Tue" },
    { key: "Wed", label: "Wed" },
    { key: "Thu", label: "Thu" },
    { key: "Fri", label: "Fri" },
    { key: "Sat", label: "Sat" },
  ];

  const [workingDays, setWorkingDays] = useState([]);

  const getWorkingSchedule = async () => {
    setLoading(true);
    try {
      const response = await workingSchedulesList("");
      console.log("response", response);

      if (response?.data?.status) {
        setWorkingSchedules(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Warning",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWorkingSchedule();
  }, []);

  // ✅ Staff fetch function
  const staffFatch = async () => {
    setLoading(true);
    try {
      const response = await getstaffwithid(id);
      if (response?.data?.status) {
        setTeacher(response.data.data);
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAddSalary = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("staff_id", modalData.staff_id);
      formData.append("joining_date", modalData.joining_date);
      formData.append("salary_type", modalData.salary_type);
      formData.append("working_schedule_id", modalData.working_schedule_id);
      formData.append("total_hours_per_day", modalData.total_hours_per_day);
      formData.append("current_salary", modalData.current_salary);
      formData.append("current_overtime_rate", modalData.current_overtime_rate);
      formData.append("paid_leaves_per_month", modalData.paid_leaves_per_month);
      formData.append("carry_forward", modalData.carry_forward);
      formData.append("max_carry_forward", modalData.max_carry_forward || "");
      formData.append("remarks", modalData.remarks || "");

      formData.append("working_days", JSON.stringify(workingDays));

      const fileInput = document.getElementById("joining_img");
      if (fileInput?.files[0]) {
        formData.append("joining_img", fileInput.files[0]);
      }

      const response = await EmploymentAdd(formData);

      if (response.data.status) {
        setModalData({});
        setWorkingDays([]);
        e.target.reset();

        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Added Successfully",
        }).then(() => {
          staffFatch();
          closeModal("salary_add");
        });
      }
    } catch (err) {
      SweetAlertShow("error", "Error", err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEmploymentRevision = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("staff_id", modalData.staff_id);
      formData.append("joining_date", modalData.joining_date);
      formData.append("salary_type", modalData.salary_type);
      formData.append(
        "working_schedule_id",
        modalData.working_schedule_id || "",
      );
      formData.append("total_hours_per_day", modalData.total_hours_per_day);
      formData.append("current_salary", modalData.current_salary);
      formData.append("current_overtime_rate", modalData.current_overtime_rate);
      formData.append("paid_leaves_per_month", modalData.paid_leaves_per_month);
      formData.append("carry_forward", modalData.carry_forward);
      formData.append("max_carry_forward", modalData.max_carry_forward || "");
      formData.append("remarks", modalData.remarks || "");

      formData.append("working_days", JSON.stringify(workingDays));

      const fileInput = document.getElementById("revision_joining_img");

      if (fileInput?.files[0]) {
        formData.append("joining_img", fileInput.files[0]);
      }

      const response = await EmploymentRevision(formData);

      if (response.data.status) {
        ToastMain.fire({
          icon: "success",
          title: response.data.message,
        }).then(() => {
          closeModal("salary_revision");
          staffFatch();
        });
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSalaryChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await salaryUpdate(formData);
      if (response.data.status) {
        e.target.reset();
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "successfully",
        }).then(() => {
          staffFatch();
          closeModal("salary_update");
        });
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    staffFatch();
  }, [id]);
  useEffect(() => {
    // ❗ Update mode में overwrite मत करो
    if (modalData?.id) return;

    if (!modalData?.working_schedule_id) {
      setWorkingDays([]);
      return;
    }

    const schedule = workingSchedules.find(
      (s) => String(s.id) === String(modalData.working_schedule_id),
    );

    if (schedule?.working_days) {
      try {
        const parsedDays = JSON.parse(schedule.working_days);
        setWorkingDays(parsedDays);
      } catch {
        setWorkingDays([]);
      }
    } else {
      setWorkingDays([]);
    }
  }, [modalData?.working_schedule_id, workingSchedules]);

  const handleDayChange = (dayKey) => {
    setWorkingDays((prev) =>
      prev.includes(dayKey)
        ? prev.filter((d) => d !== dayKey)
        : [...prev, dayKey],
    );
  };

  if (loading) return <p>Loading...</p>;
  // if (!teacher) return <p>No teacher data found</p>;

  const openEmploymentRevision = () => {
    if (!teacher?.employment_histories?.length) return;

    // Get latest active employment
    const currentEmployment = [...teacher.employment_histories]
      .filter((item) => item.status == "1")
      .sort((a, b) => {
        return (
          new Date(b.joining_date).getTime() -
          new Date(a.joining_date).getTime()
        );
      })[0];

    if (!currentEmployment) {
      SweetAlertShow("info", "Warning", "No active employment record found.");
      return;
    }

    setModalData({
      ...currentEmployment,
    });

    try {
      setWorkingDays(
        currentEmployment?.working_days
          ? JSON.parse(currentEmployment.working_days)
          : [],
      );
    } catch {
      setWorkingDays([]);
    }
  };

  return (
    <div>
      {/* Salary Info */}
      {/* <pre>{JSON.stringify(teacher, null , 2)}</pre> */}
      {/* Salary Summary */}

      <div className="row g-3 mb-4">
        <div className="col-xl-3 col-md-6 mb-3">
          <div
            className="card border-0 shadow-sm h-100"
            style={{
              borderRadius: "18px",
            }}
          >
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <div
                    className="text-muted"
                    style={{
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  >
                    Current Salary
                  </div>
                </div>

                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: 60,
                    height: 60,
                    background: "#eaf7ef",
                  }}
                >
                  <i
                    className="ri-money-rupee-circle-line"
                    style={{
                      fontSize: 30,
                      color: "#22c55e",
                    }}
                  />
                </div>
              </div>

              <h2
                className="fw-bold mb-2"
                style={{
                  fontSize: "2rem",
                  wordBreak: "break-word",
                }}
              >
                ₹
                {Number(
                  teacher?.employment_histories?.[0]?.current_salary || 0,
                ).toLocaleString("en-IN")}
              </h2>

              <small className="text-success fw-semibold">Monthly Salary</small>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-3">
          <div
            className="card border-0 shadow-sm h-100"
            style={{ borderRadius: 18 }}
          >
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="text-muted fw-semibold">Salary Type</div>

                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: 60,
                    height: 60,
                    background: "#f2ebff",
                  }}
                >
                  <i
                    className="ri-bank-card-line"
                    style={{
                      fontSize: 28,
                      color: "#7c3aed",
                    }}
                  />
                </div>
              </div>

              <h2
                className="fw-bold"
                style={{
                  fontSize: "2rem",
                }}
              >
                {teacher?.employment_histories?.[0]?.salary_type || "-"}
              </h2>

              <small className="text-muted">Payroll Cycle</small>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-3">
          <div
            className="card border-0 shadow-sm h-100"
            style={{ borderRadius: 18 }}
          >
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="text-muted fw-semibold">Working Hours</div>

                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: 60,
                    height: 60,
                    background: "#fff4de",
                  }}
                >
                  <i
                    className="ri-time-line"
                    style={{
                      fontSize: 28,
                      color: "#f59e0b",
                    }}
                  />
                </div>
              </div>

              <h2
                className="fw-bold"
                style={{
                  fontSize: "2rem",
                }}
              >
                {teacher?.employment_histories?.[0]?.total_hours_per_day || 0}
              </h2>

              <small className="text-muted">Hours / Day</small>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-3">
          <div
            className="card border-0 shadow-sm h-100"
            style={{ borderRadius: 18 }}
          >
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="text-muted fw-semibold">Paid Leaves</div>

                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: 60,
                    height: 60,
                    background: "#e8f7fd",
                  }}
                >
                  <i
                    className="ri-calendar-check-line"
                    style={{
                      fontSize: 28,
                      color: "#0ea5e9",
                    }}
                  />
                </div>
              </div>

              <h2
                className="fw-bold"
                style={{
                  fontSize: "2rem",
                }}
              >
                {teacher?.employment_histories?.[0]?.paid_leaves_per_month || 0}
              </h2>

              <small className="text-muted">Per Month</small>
            </div>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-header bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-1">Salary History</h5>

              <small className="text-muted">
                Salary revisions and employment details
              </small>
            </div>

            <div className="d-flex gap-2">
              {!hasSalary ? (
                hasAccess("/staff/salary/add") && (
                  <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#salary_add"
                    onClick={() => {
                      setModalData({
                        staff_id: teacher?.id,
                        joining_date: "",
                        salary_type: "",
                        working_schedule_id: "",
                        total_hours_per_day: "",
                        current_salary: "",
                        current_overtime_rate: "",
                        paid_leaves_per_month: "",
                        carry_forward: "2",
                        max_carry_forward: "",
                        remarks: "",
                      });

                      setWorkingDays([]);
                    }}
                  >
                    <i className="ri-add-line me-1"></i>
                    Add Salary
                  </button>
                )) : (
                hasAccess("/staff/salary/revision") && (
                  <button
                    className="btn btn-success"
                    data-bs-toggle="modal"
                    data-bs-target="#salary_revision"
                    onClick={openEmploymentRevision}
                  >
                    <i className="ri-history-line me-1"></i>
                    Revise Employment
                  </button>
                ))}
            </div>
          </div>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Joining</th>

                  <th>Salary</th>

                  <th>OT Rate</th>

                  <th>Hours</th>

                  <th>Leaves</th>

                  <th>Type</th>

                  <th width="90">Action</th>
                </tr>
              </thead>

              <tbody>
                {teacher?.employment_histories?.length ? (
                  [...teacher.employment_histories]
                    .sort((a, b) => {
                      // Active employment first
                      if (a.status == "1" && b.status != "1") return -1;
                      if (a.status != "1" && b.status == "1") return 1;

                      // Then latest joining date first
                      return (
                        new Date(b.joining_date).getTime() -
                        new Date(a.joining_date).getTime()
                      );
                    })
                    .map((sal) => (
                      <tr key={sal.id}>
                        <td>
                          <div className="fw-semibold">{sal.joining_date}</div>
                        </td>

                        <td>
                          <div className="fw-bold text-success">
                            ₹{sal.current_salary}
                          </div>
                        </td>

                        <td>₹{sal.current_overtime_rate}</td>

                        <td>{sal.total_hours_per_day} hrs</td>

                        <td>
                          <span className="badge rounded-pill bg-label-info">
                            {sal.paid_leaves_per_month}
                          </span>
                        </td>

                        <td>
                          <span className="badge rounded-pill bg-label-primary">
                            {sal.salary_type}
                          </span>
                        </td>

                        <td>
                          {hasAccess("/staff/salary/update") && (
                            <button
                              className="btn btn-sm btn-outline-primary rounded-pill"
                              data-bs-toggle="modal"
                              data-bs-target="#salary_update"
                              onClick={() => {
                                const data = sal;

                                setModalData(data);

                                if (data?.working_days) {
                                  try {
                                    setWorkingDays(
                                      JSON.parse(data.working_days),
                                    );
                                  } catch {
                                    setWorkingDays([]);
                                  }
                                } else {
                                  setWorkingDays([]);
                                }
                              }}
                            >
                              <i className="ri-edit-line"></i>
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-5">
                      <div>
                        <i
                          className="ri-bank-card-line"
                          style={{
                            fontSize: 50,
                            color: "#c5c5c5",
                          }}
                        ></i>

                        <h5 className="mt-3">No Salary Record Found</h5>

                        <p className="text-muted mb-0">
                          Click "Add Salary" to create one.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="salary_add"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleAddSalary}>
              {/* HEADER */}
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5">Add Salary</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              {/* BODY */}
              <div className="modal-body">
                <div className="row g-4">
                  <input
                    name="staff_id"
                    required
                    type="hidden"
                    value={modalData?.staff_id || ""}
                  />

                  {/* Joining Date */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="date"
                        name="joining_date"
                        required
                        className="form-control"
                        value={modalData?.joining_date || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            joining_date: e.target.value,
                          }))
                        }
                      />
                      <label>Joining Date</label>
                    </div>
                  </div>

                  {/* Salary Type */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-control"
                        name="salary_type"
                        required
                        value={modalData?.salary_type || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            salary_type: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Salary Type</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Hourly">Hourly</option>
                      </select>
                      <label>Salary Type</label>
                    </div>
                  </div>

                  {/* Working Schedule (Only Monthly) */}
                  {modalData?.salary_type === "Monthly" && (
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <select
                          className="form-control"
                          name="working_schedule_id"
                          value={modalData?.working_schedule_id || ""}
                          onChange={(e) => {
                            const selectedId = e.target.value;

                            const selectedSchedule = workingSchedules.find(
                              (s) => String(s.id) === String(selectedId),
                            );

                            setModalData((prev) => ({
                              ...prev,
                              working_schedule_id: selectedId,
                              total_hours_per_day:
                                selectedSchedule?.total_hours_per_day || "",
                            }));

                            // Auto-select working days from API
                            if (selectedSchedule?.working_days) {
                              try {
                                setWorkingDays(
                                  JSON.parse(selectedSchedule.working_days),
                                );
                              } catch {
                                setWorkingDays([]);
                              }
                            } else {
                              setWorkingDays([]);
                            }
                          }}
                        >
                          <option value="">-- No Working Schedule --</option>
                          {workingSchedules.map((schedule) => (
                            <option key={schedule.id} value={schedule.id}>
                              {schedule.name} ({formatTime(schedule.start_time)}{" "}
                              - {formatTime(schedule.end_time)})
                            </option>
                          ))}
                        </select>
                        <label>Working Schedule</label>
                      </div>
                    </div>
                  )}

                  {/* Working Hours */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="total_hours_per_day"
                        required
                        className="form-control"
                        value={modalData?.total_hours_per_day || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            total_hours_per_day: e.target.value,
                          }))
                        }
                      />
                      <label>Working Hours Per Day</label>
                    </div>
                  </div>

                  {/* Salary */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="current_salary"
                        className="form-control"
                        required
                        value={modalData?.current_salary || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_salary: e.target.value,
                          }))
                        }
                      />
                      <label>Salary</label>
                    </div>
                  </div>

                  {/* Overtime */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="current_overtime_rate"
                        className="form-control"
                        value={modalData?.current_overtime_rate || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_overtime_rate: e.target.value,
                          }))
                        }
                      />
                      <label>Overtime Rate (Per Hours)</label>
                    </div>
                  </div>

                  {/* Leaves */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="paid_leaves_per_month"
                        className="form-control"
                        value={modalData?.paid_leaves_per_month || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            paid_leaves_per_month: e.target.value,
                          }))
                        }
                      />
                      <label>Paid Leaves Per Month</label>
                    </div>
                  </div>

                  {/* Carry Forward */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select"
                        name="carry_forward"
                        value={modalData?.carry_forward || "2"}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            carry_forward: e.target.value,
                          }))
                        }
                      >
                        <option value="2">No</option>
                        <option value="1">Yes</option>
                      </select>
                      <label>Paid Leaves Carry Forward</label>
                    </div>
                  </div>

                  {/* Max Carry Forward */}
                  {modalData?.carry_forward === "1" && (
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="number"
                          name="max_carry_forward"
                          className="form-control"
                          value={modalData?.max_carry_forward || ""}
                          onChange={(e) =>
                            setModalData((prev) => ({
                              ...prev,
                              max_carry_forward: e.target.value,
                            }))
                          }
                        />
                        <label>Maximum Paid Leaves Carry Forward</label>
                      </div>
                    </div>
                  )}

                  {/* Remark */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        className="form-control input-uppercase"
                        name="remarks"
                        value={modalData?.remarks || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            remarks: e.target.value,
                          }))
                        }
                      />
                      <label>Remark</label>
                    </div>
                  </div>

                  {/* File */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="file"
                        name="joining_img"
                        className="form-control"
                      />
                      <label>Joining Later Img</label>
                    </div>
                  </div>

                  {/* Working Days */}
                  <div className="col-md-12">
                    <label className="fw-semibold mb-2">Working Days</label>
                    <div className="d-flex flex-wrap gap-4">
                      {daysList.map((day) => (
                        <div className="form-check" key={day.key}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={workingDays.includes(day.key)}
                            onChange={() => handleDayChange(day.key)}
                            name="working_days[]"
                            value={day.key}
                          />
                          <label className="form-check-label">
                            {day.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* FOOTER */}
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Salary
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="salary_update"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form action="" onSubmit={handleSalaryChange}>
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Salary Update
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row g-4">
                  <input
                    type="hidden"
                    name="id"
                    id="id"
                    value={modalData?.id}
                  />
                  <input
                    type="hidden"
                    name="staff_id"
                    id="staff_id"
                    value={modalData?.staff_id}
                  />

                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="date"
                        className="form-control"
                        name="joining_date"
                        id="joining_date"
                        value={modalData?.joining_date}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            joining_date: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="joining_date">Joining Date</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <select
                        name="salary_type"
                        id="salary_type"
                        className="form-control"
                        value={modalData?.salary_type}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            salary_type: e.target.value,
                          }))
                        }
                      >
                        <option value="" selected disabled>
                          Select Salary Type
                        </option>
                        <option value="Monthly">Monthly</option>
                        <option value="Hourly">Hourly</option>
                      </select>
                      <label htmlFor="">Salary Type</label>
                    </div>
                  </div>
                  {modalData?.salary_type == "Monthly" && (
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <select
                          name="working_schedule_id"
                          className="form-control"
                          value={modalData?.working_schedule_id || ""}
                          onChange={(e) => {
                            const selectedId = e.target.value;

                            const selectedSchedule = workingSchedules.find(
                              (s) => String(s.id) === String(selectedId),
                            );

                            setModalData((prev) => ({
                              ...prev,
                              working_schedule_id: selectedId,
                              total_hours_per_day:
                                selectedSchedule?.total_hours_per_day || "",
                            }));

                            if (selectedSchedule?.working_days) {
                              try {
                                setWorkingDays(
                                  JSON.parse(selectedSchedule.working_days),
                                );
                              } catch {
                                setWorkingDays([]);
                              }
                            } else {
                              setWorkingDays([]);
                            }
                          }}
                        >
                          <option value="">-- No Working Schedule --</option>

                          {workingSchedules.map((schedule) => (
                            <option key={schedule.id} value={schedule.id}>
                              {schedule.name} ({formatTime(schedule.start_time)}{" "}
                              - {formatTime(schedule.end_time)})
                            </option>
                          ))}
                        </select>

                        <label>Working Schedule</label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="total_hours_per_day"
                        id="total_hours_per_day"
                        value={modalData?.total_hours_per_day}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            total_hours_per_day: e.target.value,
                          }))
                        }
                        readOnly={
                          modalData?.salary_type == "Monthly" &&
                            modalData?.working_schedule_id
                            ? true
                            : false
                        }
                        placeholder="Working Hours Per Day"
                      />
                      <label htmlFor="total_hours_per_day">
                        Working Hours Per Day
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="current_salary"
                        id="current_salary"
                        placeholder="Salary"
                        value={modalData?.current_salary}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_salary: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="current_salary">Salary</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="current_overtime_rate"
                        id="current_overtime_rate"
                        placeholder="Overtime Rate (Per Hours)"
                        value={modalData?.current_overtime_rate}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_overtime_rate: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="current_overtime_rate">
                        Overtime Rate (Per Hours)
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="number"
                        className="form-control"
                        name="paid_leaves_per_month"
                        id="paid_leaves_per_month"
                        placeholder="Paid Leaves Per Month"
                        value={modalData?.paid_leaves_per_month}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            paid_leaves_per_month: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="paid_leaves_per_month">
                        Paid Leaves Per Month
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline">
                      <select
                        name="carry_forward"
                        id="carry_forward"
                        className="form-select"
                        value={modalData?.carry_forward}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            carry_forward: e.target.value,
                          }))
                        }
                      >
                        <option value="2">No</option>
                        <option value="1">Yes</option>
                      </select>
                      <label htmlFor="carry_forward">
                        Paid Leaves Carry Forward
                      </label>
                    </div>
                  </div>

                  {modalData?.carry_forward == "1" && (
                    <div className="col-md-6">
                      <div className=" form-floating form-floating-outline ">
                        <input
                          type="number"
                          className="form-control"
                          name="max_carry_forward"
                          id="max_carry_forward"
                          placeholder=" Maximum Paid Leaves Carry Forward"
                          value={modalData?.max_carry_forward}
                          onChange={(e) =>
                            setModalData((prev) => ({
                              ...prev,
                              max_carry_forward: e.target.value,
                            }))
                          }
                        />
                        <label htmlFor="max_carry_forward">
                          Maximum Paid Leaves Carry Forward
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <textarea
                        type="text"
                        className="form-control input-uppercase"
                        name="remarks"
                        id="remarks"
                        placeholder="Remark"
                        value={modalData?.remarks}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            remarks: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="remarks">Remark</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <textarea
                        type="text"
                        className="form-control input-uppercase"
                        name="reason"
                        id="reason"
                        placeholder="Reason for Change"
                      />
                      <label htmlFor="reason">Reason for Change</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="date"
                        className="form-control"
                        name="effective_from"
                        id="effective_from"
                        min={
                          modalData?.joining_date
                            ? new Date(modalData.joining_date)
                              .toISOString()
                              .split("T")[0]
                            : ""
                        }
                      />

                      <label htmlFor="effective_from">Effective From</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" form-floating form-floating-outline ">
                      <input
                        type="file"
                        className="form-control"
                        name="joining_img"
                        id="joining_img"
                      />
                      <label htmlFor="joining_img">Joining Later Img</label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <label className="fw-semibold mb-2">Working Days</label>

                    <div className="d-flex flex-wrap gap-4">
                      {daysList.map((day) => (
                        <div className="form-check" key={day.key}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            value={day.key}
                            name="working_days[]"
                            checked={workingDays.includes(day.key)}
                            onChange={() => handleDayChange(day.key)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`day_${day.key}`}
                          >
                            {day.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="salary_revision"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleEmploymentRevision}>
              {/* HEADER */}
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5">Revise Employment</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
              </div>

              {/* BODY */}
              <div className="modal-body">
                <div className="row g-4">
                  <input
                    name="staff_id"
                    required
                    type="hidden"
                    value={modalData?.staff_id || ""}
                  />

                  {/* Joining Date */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="date"
                        name="joining_date"
                        required
                        className="form-control"
                        value={modalData?.joining_date || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            joining_date: e.target.value,
                          }))
                        }
                      />
                      <label>Joining Date</label>
                    </div>
                  </div>

                  {/* Salary Type */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-control"
                        name="salary_type"
                        required
                        value={modalData?.salary_type || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            salary_type: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select Salary Type</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Hourly">Hourly</option>
                      </select>
                      <label>Salary Type</label>
                    </div>
                  </div>

                  {/* Working Schedule (Only Monthly) */}
                  {modalData?.salary_type === "Monthly" && (
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <select
                          className="form-control"
                          name="working_schedule_id"
                          value={modalData?.working_schedule_id || ""}
                          onChange={(e) => {
                            const selectedId = e.target.value;

                            const selectedSchedule = workingSchedules.find(
                              (s) => String(s.id) === String(selectedId),
                            );

                            setModalData((prev) => ({
                              ...prev,
                              working_schedule_id: selectedId,
                              total_hours_per_day:
                                selectedSchedule?.total_hours_per_day || "",
                            }));

                            // Auto-select working days
                            if (selectedSchedule?.working_days) {
                              try {
                                setWorkingDays(
                                  JSON.parse(selectedSchedule.working_days),
                                );
                              } catch {
                                setWorkingDays([]);
                              }
                            } else {
                              setWorkingDays([]);
                            }
                          }}
                        >
                          <option value="">-- No Working Schedule --</option>
                          {workingSchedules.map((schedule) => (
                            <option key={schedule.id} value={schedule.id}>
                              {schedule.name} ({formatTime(schedule.start_time)}{" "}
                              - {formatTime(schedule.end_time)})
                            </option>
                          ))}
                        </select>
                        <label>Working Schedule</label>
                      </div>
                    </div>
                  )}

                  {/* Working Hours */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="total_hours_per_day"
                        required
                        className="form-control"
                        value={modalData?.total_hours_per_day || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            total_hours_per_day: e.target.value,
                          }))
                        }
                      />
                      <label>Working Hours Per Day</label>
                    </div>
                  </div>

                  {/* Salary */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="current_salary"
                        className="form-control"
                        required
                        value={modalData?.current_salary || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_salary: e.target.value,
                          }))
                        }
                      />
                      <label>Salary</label>
                    </div>
                  </div>

                  {/* Overtime */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="current_overtime_rate"
                        className="form-control"
                        value={modalData?.current_overtime_rate || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            current_overtime_rate: e.target.value,
                          }))
                        }
                      />
                      <label>Overtime Rate (Per Hours)</label>
                    </div>
                  </div>

                  {/* Leaves */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        name="paid_leaves_per_month"
                        className="form-control"
                        value={modalData?.paid_leaves_per_month || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            paid_leaves_per_month: e.target.value,
                          }))
                        }
                      />
                      <label>Paid Leaves Per Month</label>
                    </div>
                  </div>

                  {/* Carry Forward */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select"
                        name="carry_forward"
                        value={modalData?.carry_forward || "2"}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            carry_forward: e.target.value,
                          }))
                        }
                      >
                        <option value="2">No</option>
                        <option value="1">Yes</option>
                      </select>
                      <label>Paid Leaves Carry Forward</label>
                    </div>
                  </div>

                  {/* Max Carry Forward */}
                  {modalData?.carry_forward === "1" && (
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline">
                        <input
                          type="number"
                          name="max_carry_forward"
                          className="form-control"
                          value={modalData?.max_carry_forward || ""}
                          onChange={(e) =>
                            setModalData((prev) => ({
                              ...prev,
                              max_carry_forward: e.target.value,
                            }))
                          }
                        />
                        <label>Maximum Paid Leaves Carry Forward</label>
                      </div>
                    </div>
                  )}

                  {/* Remark */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        className="form-control input-uppercase"
                        name="remarks"
                        value={modalData?.remarks || ""}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            remarks: e.target.value,
                          }))
                        }
                      />
                      <label>Remark</label>
                    </div>
                  </div>

                  {/* File */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="file"
                        id="revision_joining_img"
                        name="joining_img"
                        className="form-control"
                      />
                      <label>Joining Later Img</label>
                    </div>
                  </div>

                  {/* Working Days */}
                  <div className="col-md-12">
                    <label className="fw-semibold mb-2">Working Days</label>
                    <div className="d-flex flex-wrap gap-4">
                      {daysList.map((day) => (
                        <div className="form-check" key={day.key}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={workingDays.includes(day.key)}
                            onChange={() => handleDayChange(day.key)}
                            name="working_days[]"
                            value={day.key}
                          />
                          <label className="form-check-label">
                            {day.label}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* FOOTER */}
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save Salary
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleryDetails;
